import React, { Component } from 'react';

import { Form, Checkbox, message, Modal as IModal } from 'antd';

import fetch from './../services/fetch';

import Modal from './Modal';

const FormItem = Form.Item;

const views = [
    [
        { label: '序号', key: 'recordNo', value: false },
        { label: '二级部门', key: 'superOrgName', value: false },
        { label: '部门', key: 'orgName', value: false },
        { label: '开课部门', key: 'kkOrgName', value: false },
        { label: '评价项目', key: 'itemName', value: false },
        { label: '教师姓名', key: 'realName', value: false },
        { label: '教师工号', key: 'employeeCode', value: false },
        { label: '教师性质', key: 'teacherPropertyName', value: false },
        { label: '评价人二级部门', key: 'customerSuperOrgName', value: false },
        { label: '评价人部门', key: 'customerOrgName', value: false },
        { label: '评价人', key: 'dudaoName', value: false },
        { label: '评价人工号', key: 'customerCode', value: false },
        { label: '评价人性质', key: 'customerteacherPropertyName', value: false },
        { label: '班级名称', key: 'className', value: false },
        { label: '年级', key: 'classGrade', value: false },
        { label: '课程名称', key: 'courseName', value: false },
        { label: '分数', key: 'resultScore', value: false },
        { label: '等级', key: 'resultGrade', value: false },
        { label: '评语', key: 'resultComment', value: false },
        { label: '上课地址', key: 'courseAdd', value: false },
        { label: '节次', key: 'lessonNum', value: false },
        { label: '星期', key: 'weekName', value: false },
        { label: '周次', key: 'weekNum', value: false },
        { label: '应到人数', key: 'totalStudent', value: false },
        { label: '实到人数', key: 'attendStudent', value: false },
        { label: '迟到人数', key: 'lateStudent', value: false },
        { label: '听课情况内容', key: 'listenComment', value: false },
        { label: '所属学期', key: 'termName', value: false },
        { label: '预提交日期', key: 'evalTime', value: false },
        { label: '提交状态', key: 'cnResultState', value: false },
        { label: '提交时间', key: 'submitTime', value: false },
        { label: '数据跟踪', key: 'dataSource', value: false },
        { label: '创建日期', key: 'createTime', value: false }
    ],

    [
        { label: '序号', key: 'recordNo', value: false },
        { label: '部门', key: 'orgName', value: false },
        { label: '教师姓名', key: 'realName', value: false },
        { label: '平均分', key: 'resultScore', value: false }
    ],

    [
        { label: '序号', key: 'recordNo', value: false },
        { label: '教师姓名', key: 'realName', value: false },
        { label: '部门', key: 'orgName', value: false },
        { label: '评价方', key: 'evalName', value: false },
        { label: '评价分数', key: 'evalScore', value: false },
        { label: '调整后分数', key: 'modifyScore', value: false },
        { label: '标准分', key: 'standardScore', value: false },
        { label: '权重', key: 'evalWeight', value: false },
        { label: '实际得分', key: 'realScore', value: false },
        { label: '等级', key: 'grade', value: false },
        { label: '所属学期', key: 'termName', value: false }
    ],

    [
        { label: '序号', key: 'recordNo', value: false },
        { label: '教师姓名', key: 'realName', value: false },
        { label: '部门', key: 'orgName', value: false },
        { label: '评价方', key: 'evalName', value: false },
        { label: '评价分数', key: 'evalScore', value: false },
        { label: '调整后分数', key: 'modifyScore', value: false },
        { label: '标准分', key: 'standardScore', value: false },
        { label: '权重', key: 'evalWeight', value: false },
        { label: '实际得分', key: 'realScore', value: false },
        { label: '等级', key: 'grade', value: false },
        { label: '所属学期', key: 'termName', value: false }
    ],

    [
        { label: '序号', key: 'recordNo', value: false },
        { label: '评价人姓名', key: 'dudaoName', value: false },
        { label: '评价人工号', key: 'customerCode', value: false },
        { label: '平均分', key: 'resultScore', value: false },
        { label: '标准差', key: 'stdDeviation', value: false },
        { label: '评价次数', key: 'evalNum', value: false }
    ]

];

class Print extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recordNo: true,

            views: views[this.props.index]
        };
    }

    componentDidMount() {
        this.querySearch();
    }

    querySearch() {
        fetch.post(this.props.url, {
            printIdentity: this.props.printIdentity
        })
            .then(response => (response.payload.data || {}))
            .then(data => (data.printFields || "").split(','))
            .then(prints => {
                const codes = {};

                prints.forEach(key => {
                    codes[key] = true;
                });

                const views = this.state.views.map(d => {
                    return Object.assign({}, d, { value: !!codes[d.key] })
                });

                this.setState({
                    views: views
                });
            });
    }

    handleChange(data, i) {
        const views = [...this.state.views];
        views[i] = data;

        this.setState({
            views: views
        })
    }

    handleSubmit() {
        event.preventDefault();
        this.props.handleCancel();
        const fields = this.state.views
            .filter(d => d.value).map(d => d.key).join('_');
        if (fields !== '') {
            fetch.post(this.props.save, {
                printIdentity: this.props.printIdentity,
                fields
            })
                .then(d => {
                    if (d.code === 200) {
                        message.success("打印设置成功!");
                    }
                });
        } else {
            IModal.warn({
                title: '提示',
                content: '请至少选择一项设置',
                okText: '确定',
                cancelText: '取消'
            })
        }
    }

    handleCancel() {
        this.props.handleCancel();
    }

    render() {
        return (
            <Modal title={this.props.title ? this.props.title : "打印设置"} width="485px" styleName="root-modal-print" visible={this.props.visible} handleSubmit={this.handleSubmit.bind(this)} handleCancel={this.handleCancel.bind(this)}>
                <Form layout="inline" onSubmit={this.handleSubmit.bind(this)}>
                    {this.state.views.map((d, index) => (
                        <FormItem label={d.label}>
                            <Checkbox checked={d.value} onChange={(event) => {
                                const data = Object.assign({}, d, { value: !!event.target.checked });
                                this.handleChange(data, index);
                            }}></Checkbox>
                        </FormItem>
                    ))}
                </Form>
            </Modal>
        );
    }
}

export default Print;
